mutation UserProfileDisable(
  $input: UserProfileDisableInput!
) {
  userProfileDisable(input: $input) {
   entitySelections
   {
    id
    rowTimestamp
   }
  }
}
